import axios from "axios";
import { API } from "../shared/api/Api";

export const updateUserInfo = async (data, token) => {
  try {
    const response = await axios.post(
      `${API.Users.app_users_actions_updateUserInfo}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error updating info:", error);
    throw error;
  }
};

export const userDetails = async (uuid, token) => {
  try {
    const { data } = await axios.get(API.Users.userDetails, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.error("Error updating info:", error);
    throw error;
  }
};
